<ng-container *ngIf="!colorFilter; else colorFilterTemplate">
  <div class="colorpicker-col" *ngFor="let color of colorList">
    <div class="color-margin-column">
      <div class="item-wrapper">
        <div
          class="item"
          [ngStyle]="{ backgroundColor: color.hex }"
          [ngClass]="{ active: color.active }"
          (click)="onColorClicked(color)"
          [ngbTooltip]="color.name"
          placement="left"
        ></div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #colorFilterTemplate>
  <h3 class="filter-title">Szín</h3>
  <div class="color-row">
    <div class="color-wrapper" *ngFor="let colorForm of formArray.controls">
      <span
        class="item filter-item"
        [ngStyle]="{ backgroundColor: colorForm.get('hexCode').value }"
        [ngClass]="{ active: colorForm.get('active').value }"
        [ngbTooltip]="colorForm.get('name').value"
        (click)="onColorFilterClicked($any(colorForm))"
        placement="left"
      ></span>
    </div>
  </div>
</ng-template>
